/**
 * Created by Vladislav on 19.06.2024.
 */

const SocialManager = function () {

};

SocialManager.prototype.listShareChannels = function () {
    return Object.keys(SocialManager.SHARE_CHANNELS).filter((channel) => SocialManager.SHARE_CHANNELS[channel].isAvailable());
};

SocialManager.prototype.share = function (data, callback) {
    const onDone = function (code) {
        const success = code === connector.CODE_SUCCEED;

        connector.platform.getPlugin().bus.trigger("share", success, data.channel);

        callback(success);
    };

    const availableChannels = this.listShareChannels();

    if (data.channel && !availableChannels.includes(data.channel)) {
        console.error(`[connector] provided share channel not available - ${data.channel}`);
        onDone(connector.CODE_FAILED);
        return;
    }

    data.channel = data.channel || availableChannels[0];
    if (!data.channel) {
        console.error("[connector] no available share channels");
        onDone(connector.CODE_FAILED);
        return;
    }

    data = this.formatShareData(data);

    const needsBase64 = connector.platform.oneOf(connector.INSTANT, connector.TEST);

    new ConnectorActionPlayer([
        function (f) {
            if (SocialManager.SHARE_CHANNELS[data.channel].needsLogin) {
                this.enforceLogin((code) => {
                    if (code) {
                        onDone(code);
                    } else {
                        f();
                    }
                });
            } else {
                f();
            }
        }.bind(this),
        function (f) {
            if (data.image && needsBase64) {
                connector.utils.loadBase64(data.image, (base64Image) => {
                    if (base64Image) {
                        data.image = base64Image;
                        f();
                    } else {
                        onDone(connector.CODE_FAILED);
                    }
                });
            } else {
                f();
            }
        },
        function () {
            connector.platform.getPlugin().bus.trigger("share:start", data.channel);

            SocialManager.SHARE_CHANNELS[data.channel].share(data, onDone);
        }
    ]).play();
};

SocialManager.prototype.enforceLogin = function (callback) {
    if (!connector.social.isLoggedIn({ strict: true })) {
        connector.social.loginCallback((success) => {
            if (success) {
                callback();
            } else {
                callback(ERRORS.PURCHASE.LOGIN_FAILED);
            }
        });
    } else {
        callback();
    }
};

SocialManager.prototype.joinCommunity = function (callback, nativeOnly) {
    const plugin = connector.social.getPlugin();

    const onDone = function (code) {
        const success = code === connector.CODE_SUCCEED;

        plugin.bus.trigger("joinCommunity", success);

        if (callback) {
            callback(success);
        }
    };

    if (!connector.social.isSupportsNativeCommunityJoin) {
        if (nativeOnly) {
            onDone(connector.CODE_FAILED);
        } else {
            this.openCommunityUrl();

            onDone(connector.CODE_SUCCEED);
        }

        return;
    }

    if (!connector.social.isConnected()) {
        onDone(connector.CODE_FAILED);
        return;
    }

    plugin.canJoinCommunity((canJoin) => {
        if (canJoin) {
            plugin.joinCommunity(onDone);
        } else if (nativeOnly) {
            onDone(connector.CODE_FAILED);
        } else {
            this.openCommunityUrl();

            onDone(connector.CODE_SUCCEED);
        }
    });
};

SocialManager.prototype.openCommunityUrl = function () {
    connector.platform.openUrl(Platform.getGroupUrl());
};

SocialManager.prototype.request = function (data, callback) {
    const plugin = connector.social.getPlugin();

    const onDone = function (code, result) {
        const success = code === connector.CODE_SUCCEED;

        if (code) {
            plugin.bus.trigger("error:request", code);
        }

        plugin.bus.trigger("request", success);

        callback(code, result);
    };

    if (!connector.social.isConnected()) {
        onDone(connector.CODE_FAILED);
        return;
    }

    if (!connector.social.isSupportsNativeRequest) {
        onDone(connector.CODE_FAILED);
        return;
    }

    plugin.request(data, (code, result) => {
        onDone(code, result);
    });
};

// the platform's own invite where it has one, otherwise any share channel it offers
SocialManager.prototype.chooseInviteChannel = function () {
    const channels = this.listShareChannels();

    if (channels.includes("invite")) {
        return "invite";
    }

    if (channels.length) {
        return channels[Math.floor(Math.random() * channels.length)];
    }

    return "invite";
};

// options.login(done) lets the caller sign the player in its own way before a channel that needs a login;
// without it the share asks the platform directly
SocialManager.prototype.inviteFriends = function (data, callback, options) {
    callback = callback || function () {};
    options = options || {};

    const channel = this.chooseInviteChannel();
    const needsLogin = Boolean(SocialManager.SHARE_CHANNELS[channel] && SocialManager.SHARE_CHANNELS[channel].needsLogin);

    new ConnectorActionPlayer([
        function (f, stop) {
            if (!needsLogin || !options.login) {
                f();
                return;
            }

            options.login((code) => {
                if (code === connector.CODE_SUCCEED) {
                    f();
                } else {
                    callback(false);
                    stop();
                }
            });
        },

        function (f) {
            if (connector.platform.isExitFullscreenAvailable()) {
                connector.platform.exitFullscreen(f);
            } else {
                f();
            }
        },

        function () {
            this.share({ ...data, channel }, callback);
        }.bind(this)
    ]).play();
};

// ids of the player's friends who play this game, as strings, without the player and without repeats
SocialManager.prototype.checkInvitees = function (callback) {
    connector.social.listFriends((code, friends) => {
        if (code !== connector.CODE_SUCCEED || !Array.isArray(friends)) {
            callback(code === connector.CODE_SUCCEED ? connector.CODE_FAILED : code, []);
            return;
        }

        const own = String(connector.platform.getUserID());
        const ids = friends
            .map((friend) => (friend && friend.id !== undefined && friend.id !== null ? String(friend.id) : ""))
            .filter((id, index, list) => id && id !== own && list.indexOf(id) === index);

        callback(connector.CODE_SUCCEED, ids);
    });
};

SocialManager.prototype.formatShareData = function (data) {
    if (!data) {
        data = {};
    }

    data.title = data.title || document.title;
    data.url = data.url || connector.utils.guessPlatformURL();

    return data;
};

SocialManager.SHARE_CHANNELS = {
    "shareNative": {
        isAvailable: function () {
            const plugin = connector.platform.getPlugin();
            return plugin.isConnected() && plugin.isShareSupported();
        },
        share: function (data, callback) {
            connector.platform.getPlugin().shareNative(data, callback);
        }
    },
    "share": {
        needsLogin: true,
        isAvailable: function () {
            const plugin = connector.social.getPlugin();
            return plugin.isConnected() && plugin.isShareSupported();
        },
        share: function (data, callback) {
            connector.social.getPlugin().share(data, callback);
        }
    },
    "invite": {
        needsLogin: true,
        isAvailable: function () {
            const plugin = connector.social.getPlugin();
            return plugin.isConnected() && plugin.isInviteSupported();
        },
        share: function (data, callback) {
            connector.social.getPlugin().invite(data, callback);
        }
    }
};